import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { dataLabTypesState, fetchLabTypes } from '../../store'
import { STORAGE_TOKEN_KEY } from '../../api/constant'
import { useRecoilState } from 'recoil'

export default function useFetchLabTypes(setLoading) {
  const history = useHistory()

  const [labTypes, setLabTypes] = useRecoilState(dataLabTypesState)

  useEffect(() => {
    let isApiSubscribed = true
    if (isApiSubscribed) {
      setLoading(true)
      fetchLabTypes((data, err) => {
        isApiSubscribed = false

        if (err) {
          if (err.redirect) {
            localStorage.removeItem(STORAGE_TOKEN_KEY)
            history.push('/login')
          }
          isApiSubscribed = false
        } else {
          setLabTypes(data)
        }
        setLoading(false)
      })
    }

    return () => {
      // cancel the subscription
      isApiSubscribed = false
    }
  }, [history, setLoading, setLabTypes])

  return { labTypes }
}
